import {
  BackButtonT1,
  ButtonGroup,
  ButtonT5,
} from "Components/Common/Button/index";
import { TypographyT38 } from "Components/Common/Typography/index";
import {
  FlexWrapperT2,
  FlexWrapperT3,
  FlexWrapperT9,
} from "Components/Common/Wrapper/FlexWrapper";

import React, { Fragment } from "react";

const HeaderSection = (props) => {
  const { handleOnClickBack } = props;
  return (
    <Fragment>
      <FlexWrapperT9>
        <FlexWrapperT3>
          <BackButtonT1 onClick={handleOnClickBack} />
          <TypographyT38>EXIM Cargo Tracking</TypographyT38>
        </FlexWrapperT3>
        <ButtonGroup>
          <ButtonT5 active={true}>Sea Shipment</ButtonT5>
          {/* <ButtonT5 active={false}>Air Shipment</ButtonT5> */}
        </ButtonGroup>
      </FlexWrapperT9>
    </Fragment>
  );
};

export default HeaderSection;
